// extracted by mini-css-extract-plugin
export default {"container":"FormErrorBoundary_container__hrJXz"};